module.exports = __webpack_public_path__ + "static/img/bannerorange.5449bb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bannerorange.png
// module id = 294
// module chunks = 1